import { useState } from "react";
import SectionShell from "@/pages/home/components/SectionShell";
import { faqs } from "@/mocks/home";

export default function FaqSection() {
  const [active, setActive] = useState<number | null>(1);

  return (
    <SectionShell
      id="faq"
      num="06"
      eyebrow="QUESTIONS"
      title="常见答疑：看之前你可能想问的"
      desc="时长、清晰度、字幕、链接失效与是否需要登录，集中回答在这，省去反复查找。"
      tone="tint"
    >
      <div className="mx-auto flex w-full max-w-3xl flex-col gap-3">
        {faqs.map((item) => {
          const open = active === item.id;
          return (
            <div
              key={item.id}
              className={[
                "overflow-hidden rounded-xl border transition-colors",
                open ? "border-accent-300/70 bg-background-50" : "border-background-200/70 bg-background-50",
              ].join(" ")}
            >
              <button
                type="button"
                onClick={() => setActive(open ? null : item.id)}
                className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left md:px-6 md:py-5"
              >
                <span className="flex items-center gap-3">
                  <span
                    className={[
                      "flex h-7 w-7 shrink-0 items-center justify-center rounded-md font-heading text-xs font-bold",
                      open
                        ? "bg-accent-500 text-background-50"
                        : "bg-background-200 text-foreground-700",
                    ].join(" ")}
                  >
                    Q
                  </span>
                  <span className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                    {item.q}
                  </span>
                </span>
                <i
                  className={[
                    "shrink-0 text-xl text-foreground-500 transition-transform duration-300",
                    open ? "ri-subtract-line rotate-180 text-accent-500" : "ri-add-line",
                  ].join(" ")}
                />
              </button>
              {open ? (
                <div className="animate-fade-in px-5 pb-5 md:px-6 md:pb-6">
                  <p className="border-t border-background-200/70 pt-4 pl-10 text-sm leading-7 text-foreground-600">
                    {item.a}
                  </p>
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </SectionShell>
  );
}